













































import { defineComponent, ref } from "@nuxtjs/composition-api";
import PBHelper from "~/components/PageBuilder/utils/helper";

export default defineComponent({
  name: "MediaBanner",
  props: {
    tag: {
      type: String,
      default: "div",
    },
    node: {
      type: String,
      default: "div",
    },
    attr: {
      type: Object,
      default: () => {},
    },
    children: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const { createDynamicBackgroundImage } = PBHelper();
    const backgroundImage = (props.children[0] as any)?.child[0]?.attr?.['data-background-images'] || '';
    const dynamicBackgroundImage = createDynamicBackgroundImage(backgroundImage);
    const text = ref("");

    const formatSpecialAttributes = (attrs) => {
      const allowed = [
        "class",
        "data-background-type",
        "data-element",
        "data-pb-style",
      ];
      const filtered = Object.keys(attrs)
        .filter((key) => allowed.includes(key))
        .reduce((obj, key) => {
          obj[key] = attrs[key];
          return obj;
        }, {});
      return filtered;
    };

    const pb = {children: props.children};
    text.value =
      pb.children?.[0]["child"][0]["child"][0]["child"][0]["child"][0][
        "child"
      ]?.[0]["child"][0]["child"][0]["text"];

    return {
      text,
      dynamicBackgroundImage,
      formatSpecialAttributes,
    };
  },
});
